/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `WaypointStep.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { WaypointStep } from "./WaypointStep";

import { WaypointDirection } from "./WaypointDirection";

export abstract class WaypointStepModel {
    id: number;
    color: string;
    coordinates: number[] | null;
    createdAt: Dayjs;
    hidden: boolean;
    icon: string | null;
    iconRotate: number;
    instruction: string | null;
    stepNumber: number;
    updatedAt: Dayjs;
    waypointDirectionId: number;
    pictureUrl: string | null;
    waypointDirection: WaypointDirection | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        color: string,
        coordinates: number[] | null,
        createdAt: Dayjs,
        hidden: boolean,
        icon: string | null,
        iconRotate: number,
        instruction: string | null,
        stepNumber: number,
        updatedAt: Dayjs,
        waypointDirectionId: number,
        pictureUrl: string | null,
        waypointDirection: WaypointDirection | null | undefined
    ) {
        this.id = id;
        this.color = color;
        this.coordinates = coordinates;
        this.createdAt = createdAt;
        this.hidden = hidden;
        this.icon = icon;
        this.iconRotate = iconRotate;
        this.instruction = instruction;
        this.stepNumber = stepNumber;
        this.updatedAt = updatedAt;
        this.waypointDirectionId = waypointDirectionId;
        this.pictureUrl = pictureUrl;
        this.waypointDirection = waypointDirection;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): WaypointStep {
        const newObject = new WaypointStep(
            json["id"],
            json["color"],
            json["coordinates"],
            dayjs(json["created_at"]).tz(timezone),
            json["hidden"],
            json["icon"],
            json["icon_rotate"],
            json["instruction"],
            json["step_number"],
            dayjs(json["updated_at"]).tz(timezone),
            json["waypoint_direction_id"],
            json["picture_url"],
            json["waypoint_direction"] == null
                ? json["waypoint_direction"]
                : WaypointDirection.fromApiObject(json["waypoint_direction"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            color: this.color,
            coordinates: this.coordinates,
            created_at: this.createdAt,
            hidden: this.hidden,
            icon: this.icon,
            icon_rotate: this.iconRotate,
            instruction: this.instruction,
            step_number: this.stepNumber,
            updated_at: this.updatedAt,
            waypoint_direction_id: this.waypointDirectionId,
            waypoint_direction_attributes: this.waypointDirection?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): WaypointStep {
        const clone = Object.create(this) as WaypointStep;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
